import { TypeUtils } from 'common/utils/generalTypeUtils';
import { YearFilterState } from './store/year.types';

export const yearsFilterHash = (options: YearFilterState['selectedYears']): string =>
  TypeUtils.Object.keys(options ?? {})
    .filter((year) => options[year])
    .sort()
    .join('_');
